// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"147":"c0650696","777":"8082e53f"}[chunkId] + ".chunk.css";
};